import {ChemDrawStoichiometryData, ParseReactionComponentsResponse} from 'chemistry/ChemistryConstants';
import * as net from 'util/Net';

export function bulkFetchChemDrawStoichiometryData(
  noteLinkedObjectIds: Array<string>
): Promise<{[noteLinkedObjectId: string]: ChemDrawStoichiometryData}> {
  return net.postJSONPromise({
    url: '/1/api/chemistry:bulk-fetch-chemdraw-stoichiometry-data',
    data: {noteLinkedObjectIds},
  });
}

export function parseReactionComponents(mrvFile: string): Promise<ParseReactionComponentsResponse> {
  return net.postJSONPromise({
    url: '/1/api/reactions:process-components',
    data: {mrvFile},
  });
}
